var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceiptCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.34277 9.4043C2.34277 8.99008 2.67856 8.6543 3.09277 8.6543H20.9167C21.3309 8.6543 21.6667 8.99008 21.6667 9.4043C21.6667 9.81851 21.3309 10.1543 20.9167 10.1543H3.09277C2.67856 10.1543 2.34277 9.81851 2.34277 9.4043Z",
    fill: "#4546F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6919 13.3096C15.6919 12.8954 16.0277 12.5596 16.4419 12.5596H16.4512C16.8654 12.5596 17.2012 12.8954 17.2012 13.3096C17.2012 13.7238 16.8654 14.0596 16.4512 14.0596H16.4419C16.0277 14.0596 15.6919 13.7238 15.6919 13.3096Z",
    fill: "#4546F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2544 13.3096C11.2544 12.8954 11.5902 12.5596 12.0044 12.5596H12.0137C12.4279 12.5596 12.7637 12.8954 12.7637 13.3096C12.7637 13.7238 12.4279 14.0596 12.0137 14.0596H12.0044C11.5902 14.0596 11.2544 13.7238 11.2544 13.3096Z",
    fill: "#4546F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80811 13.3096C6.80811 12.8954 7.14389 12.5596 7.55811 12.5596H7.56737C7.98158 12.5596 8.31737 12.8954 8.31737 13.3096C8.31737 13.7238 7.98158 14.0596 7.56737 14.0596H7.55811C7.14389 14.0596 6.80811 13.7238 6.80811 13.3096Z",
    fill: "#4546F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6919 17.1963C15.6919 16.7821 16.0277 16.4463 16.4419 16.4463H16.4512C16.8654 16.4463 17.2012 16.7821 17.2012 17.1963C17.2012 17.6105 16.8654 17.9463 16.4512 17.9463H16.4419C16.0277 17.9463 15.6919 17.6105 15.6919 17.1963Z",
    fill: "#4546F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2544 17.1963C11.2544 16.7821 11.5902 16.4463 12.0044 16.4463H12.0137C12.4279 16.4463 12.7637 16.7821 12.7637 17.1963C12.7637 17.6105 12.4279 17.9463 12.0137 17.9463H12.0044C11.5902 17.9463 11.2544 17.6105 11.2544 17.1963Z",
    fill: "#4546F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80811 17.1963C6.80811 16.7821 7.14389 16.4463 7.55811 16.4463H7.56737C7.98158 16.4463 8.31737 16.7821 8.31737 17.1963C8.31737 17.6105 7.98158 17.9463 7.56737 17.9463H7.55811C7.14389 17.9463 6.80811 17.6105 6.80811 17.1963Z",
    fill: "#4546F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0439 1.25C16.4582 1.25 16.7939 1.58579 16.7939 2V5.29078C16.7939 5.70499 16.4582 6.04078 16.0439 6.04078C15.6297 6.04078 15.2939 5.70499 15.2939 5.29078V2C15.2939 1.58579 15.6297 1.25 16.0439 1.25Z",
    fill: "#4546F7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96533 1.25C8.37955 1.25 8.71533 1.58579 8.71533 2V5.29078C8.71533 5.70499 8.37955 6.04078 7.96533 6.04078C7.55112 6.04078 7.21533 5.70499 7.21533 5.29078V2C7.21533 1.58579 7.55112 1.25 7.96533 1.25Z",
    fill: "#4546F7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.76749 4.22937C4.76914 3.2772 6.16751 2.8291 7.77096 2.8291H16.2383C17.8457 2.8291 19.2449 3.27686 20.2448 4.23009C21.2504 5.18867 21.7548 6.56548 21.75 8.22315V17.3474C21.75 19.0051 21.243 20.3834 20.2372 21.3438C19.2366 22.2991 17.8377 22.7499 16.229 22.7499H7.77096C6.16301 22.7499 4.76302 22.2898 3.76225 21.3198C2.75774 20.3462 2.25 18.9507 2.25 17.2718V8.22213C2.25 6.5633 2.76004 5.18705 3.76749 4.22937ZM4.80096 5.31654C4.1571 5.9286 3.75 6.87387 3.75 8.22213V17.2718C3.75 18.6472 4.1594 19.6158 4.8062 20.2427C5.45673 20.8732 6.44222 21.2499 7.77096 21.2499H16.229C17.5663 21.2499 18.5528 20.878 19.2013 20.2589C19.8445 19.6448 20.25 18.6968 20.25 17.3474V8.22213L20.25 8.21983C20.2541 6.87098 19.8507 5.92674 19.2098 5.31582C18.5631 4.69931 17.5768 4.3291 16.2383 4.3291H7.77096C6.43772 4.3291 5.45061 4.69897 4.80096 5.31654Z",
    fill: "#4546F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptCalendar);
export default __webpack_public_path__ + "static/media/receiptCalendar.de84eaedc31d1e0bd6d658cd3a540199.svg";
export { ForwardRef as ReactComponent };